import React from 'react';
import Node from '../../../common/Node';
import { withStyles } from '@mui/styles';
import { connect } from 'react-redux';
import { getLastRstData } from '../../../utils';
import get from 'lodash/get';

const entityTypes = {
  NODE: 102,
  TRPL: 300,
};

const actionTypes = {
  NODE_CREATED: 'NODE_CREATED',
  NODE_DELETED: 'NODE_DELETED',
  NODE_ISA: 'NODE_ISA',
  NODE_ISA_DEL: 'NODE_ISA_DEL',
  NODE_AKO: 'NODE_AKO',
  NODE_AKO_DEL: 'NODE_AKO_DEL',
  TRPL_CREATED: 'TRPL_CREATED',
  TRPL_EDITED: 'TRPL_EDITED',
  TRPL_DELETED: 'TRPL_DELETED',
  TRPL_EVOKE: 'TRPL_EVOKE',
};

const styles = {
  highlightingText: {
    fontWeight: 800
  }
};

export default connect((state) => ({
  light_meta_and_ops: state.meta.light_meta_and_ops,
}))(withStyles(styles)(({ log, node, nodes, classes, light_meta_and_ops }) => {

  const getNodeComponent = (node, nodeId, nodes) => {
    return (
      <Node
        isLink
        size="xs"
        node={node}
        nodeId={nodeId}
        nodes={nodes}
        style={{ margin: '0 5px' }}
      />
    );
  };

  let rst;
  if (node) {
    if (node.is_individ) {
      const ancestors = get(node, ['box', 'a_explicit'], []);
      if (ancestors.length && light_meta_and_ops.setup_rbox_light) {
        const concept = light_meta_and_ops.setup_rbox_light[ancestors[0]];
        if (concept) rst = getLastRstData(log.pid, concept.id, light_meta_and_ops.setup_rbox_light);
      }
    } else {
      const rBox = get(node, ['box', 'r']);
      if (rBox) {
        loop1:
          for (const cid of Object.keys(rBox)) {
            for (const r of rBox[cid]) {
              if (r.id === log.pid) {
                rst = r;
                break loop1;
              }
            }
          }
      }
    }
  }

  return (
    <div>
      {log.entityType === entityTypes.NODE ? (

        <div>

          {log.actionType === actionTypes.NODE_CREATED || log.actionType === actionTypes.NODE_DELETED ? (
            <span>{log.json.is_individual ? 'Node' : log.json.is_ancestor ? 'Concept' : 'Node'}</span>
          ) : log.actionType === actionTypes.NODE_ISA || log.actionType === actionTypes.NODE_ISA_DEL ? (
            <span>Node</span>
          ) : log.actionType === actionTypes.NODE_AKO || log.actionType === actionTypes.NODE_AKO_DEL ? (
            <span>Concept</span>
          ) : null}

          {getNodeComponent(node, log.entityId, nodes)}

          {log.actionType === actionTypes.NODE_CREATED ? (
            <span>was created</span>
          ) : log.actionType === actionTypes.NODE_DELETED ? (
            <span>was deleted</span>
          ) : log.actionType === actionTypes.NODE_ISA || log.actionType === actionTypes.NODE_ISA_DEL ? (
            <span>
              {log.actionType === actionTypes.NODE_ISA ? 'was moved to the category ' : 'was removed from the category '}
              {log.json.isa && getNodeComponent(nodes[log.json.isa], log.json.isa, nodes)}
            </span>
          ) : log.actionType === actionTypes.NODE_AKO || log.actionType === actionTypes.NODE_AKO_DEL ? (
            <span>
              {log.actionType === actionTypes.NODE_AKO ? 'was moved to the subcategory' : 'was removed from the category'}
              {log.json.ako && getNodeComponent(nodes[log.json.ako], log.json.ako, nodes)}
            </span>
          ) : null}

        </div>

      ) : log.entityType === entityTypes.TRPL ? (

        <div>

          {log.json.created && (<span className={classes.highlightingText}>Trpl created</span>)}

          <div>
            <span className={classes.highlightingText}>Node:</span>
            {getNodeComponent(node, log.entityId, nodes)}
          </div>

          <div><span className={classes.highlightingText}>Predicate: </span>
            {rst ? rst.id + ' | ' + rst.title : log.pid}
          </div>

          {!log.TRPL_EVOKE && (
            <div>
              {log.json.old_val && (
                <div>
                  <span className={classes.highlightingText}>Old value: </span>
                  {log.json.old_val.startsWith('http') ? (
                    <a href={log.json.old_val} rel="noreferrer" target="_blank">{log.json.old_val}</a>
                  ) : (
                    log.json.old_val
                  )}
                </div>
              )}

              <div>
                {log.actionType === actionTypes.TRPL_DELETED ? (
                  <span className={classes.highlightingText}>Old value: </span>
                ) : (
                  <span className={classes.highlightingText}>New value: </span>
                )}

                {log.json.oid ? (
                  getNodeComponent(nodes[log.json.oid], log.json.oid, nodes)
                ) : log.json.url ? (
                  <span>
                    <a href={log.json.url} rel="noreferrer" target="_blank">{log.json.url}</a><br/>
                    <span className={classes.highlightingText}>Name: </span>{log.json.src_name}
                  </span>
                ) : (
                  log.json.val
                )}
              </div>

            </div>
          )}

        </div>

      ) : null}
    </div>
  );
}));